var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.edit()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_c('span',[_vm._v("Edit")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }